// Routing
export const ROUTE_REQUEST: string = "OldWata/ROUTE_REQUEST";
export const ROUTE_SUCCESS: string = "OldWata/ROUTE_SUCCESS";
export const ROUTE_FAILURE: string = "OldWata/ROUTE_FAILURE";

// Login
export const LOGIN: string = "OldWata/LOGIN";
